import { BrowserRouter, Route, Routes } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage/WelcomePage";
import MapPage from "./pages/MapPage/MapPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import QuizPage from "./pages/QuizPage/QuizPage";
import Sample from "./components/Sample";
import CastlePage from "./pages/CastlePage/CastlePage";
import CustomizePage from "./pages/CustomizePage/Customize";
// import CongratsPage from "./components/CongratsPage";
import "./index.css";
import { useState } from "react";
import { GameLoss } from "./components/GameLoss";
import { GameWin } from "./components/GameWin";
import { LeaderBoardPage } from "./pages/LeaderBoardPage/LeaderBoardPage";
// import ConqueredCastle from "./pages/CastlePage/ConqueredCastle";
// import CastlePage from "./pages/CastlePage/CastlePage";
// import WrongPage from "./components/WrongPage";
import CastleDetailsPart2 from "./pages/CastlePage/CastleDetailsPart2";
import MapLayout from "./layouts/MapLayout"; // adjust the path if needed


function App() {
  const [selectedEmblem, setSelectedEmblem] = useState(null); // Emblem
  const [selectedColor, setSelectedColor] = useState(null); // Emblem color
  const [selectedDifficulty, setSelectedDifficulty] = useState("easy"); // Difficulty
  const [selectedCastle, setSelectedCastle] = useState(null);
  const [totalPoints, setTotalPoints] = useState(0);

  console.log(totalPoints);

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<WelcomePage />} />
        <Route
          path="play"
          element={
            <MapPage
              selectedColor={selectedColor}
              selectedEmblem={selectedEmblem}
              selectedDifficulty={selectedDifficulty}
              setSelectedDifficulty={setSelectedDifficulty}
              selectedCastle={selectedCastle}
              setSelectedCastle={setSelectedCastle}
            />
          }
        />
        <Route path="login" element={<LoginPage />} />
        <Route
          path="quiz"
          element={
            <QuizPage
              totalPoints={totalPoints}
              setTotalPoints={setTotalPoints}
            />
          }
        />
        <Route path="sample" element={<GameLoss />} />

        <Route path="castle" element={<CastlePage />} />
        <Route
          path="customize"
          element={
            <CustomizePage
              selectedEmblem={selectedEmblem}
              setSelectedEmblem={setSelectedEmblem}
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
            />
          }
        />
        <Route path="leaderboard" element={<LeaderBoardPage />} />
        <Route
  path="/castle-details-part-2"
  element={
    <MapLayout>
      <CastleDetailsPart2 />
    </MapLayout>
  }
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
